module.exports = __webpack_public_path__ + "media/images/talent/flow-02-94b97148777c69a18cb7ebc28dfbe118.png";